// extracted by mini-css-extract-plugin
export default {"recos":"F5-z","productCardOverride":"G5-z","rowHasBadge":"H5-z"};